import { graphqlClient } from '@nitra/vite-boot/urql'
import { user as decodedUser } from '@nitra/vite-boot/user'
import gravatarUrl from 'gravatar-url'

const consola = createLogger(import.meta.url)

/**
 * @typedef {object} HomeUser
 * @property {string} staff_id - ідентифікатор співробітника
 * @property {string} country - код країни
 * @property {string} name - відображуване ім'я користувача
 * @property {string} orgStructureId - ідентифікатор оргструктури
 * @property {string} [email] - електронна пошта користувача
 * @property {string} [avatar] - URL аватара користувача
 * @property {Array} [apps] - перелік доступних застосунків
 */
/** @type {HomeUser} */
export const user = { apps: [] }

/**
 * Прикладення
 */
export const apps = []
let appList

const country = import.meta.env.VITE_COUNTRY
switch (country) {
  case 'ua': {
    // UA
    appList = [
      {
        logo: '/ua/caps.png',
        items: [
          { role: 'caps-user', label: 'СКіП', url: 'https://caps.abie.app' },
          { role: 'caps-admin', label: 'СКіП Admin', url: 'https://abie.app/partner-admin' },
          { role: 'partner-user', label: 'СКіП Partner', url: 'https://abie.app/partner' }
        ]
      },
      {
        title: 'Catalina',
        items: [
          { role: 'catalina-user', label: 'Catalina', url: 'https://abie.app/catalina' },
          { role: 'catalina-admin', label: 'Catalina Admin', url: 'https://abie.app/catalina-admin' }
        ]
      },
      {
        logo: '/ua/atlas.png',
        items: [
          { role: 'atlas-user', label: 'Atlas PRO', url: 'https://abie.app/atlas' },
          { role: 'atlas-admin', label: 'Atlas ADMIN', url: 'https://abie.app/atlas-admin' }
        ]
      },
      {
        logo: '/ua/matrix.png',
        items: [
          { role: 'matrix-user', label: 'Matrix PRO', url: 'https://abie.app/matrix' },
          { role: 'matrix-admin', label: 'Matrix PRO Admin', url: 'https://abie.app/matrix-admin' }
        ]
      },
      {
        title: 'Анкети',
        items: [{ role: 'survey-admin', label: 'Анкети Admin', url: 'https://abie.app/survey-admin' }]
      },
      {
        title: 'Контент',
        items: [{ role: 'content-admin', label: 'Контент Admin', url: 'https://abie.app/content-admin' }]
      },
      {
        title: 'Обладнання',
        items: [{ role: 'equipment', label: 'Обладнання Admin', url: 'https://abie.app/equipment/' }]
      },
      {
        title: 'Venom',
        items: [{ role: 'venom', label: 'Venom', url: 'https://venom.abie.app' }]
      },
      {
        logo: '/ua/b2b.png',
        items: [{ role: 'b2b-admin', label: 'B2B Admin', url: 'https://vybeerai.com.ua/admin' }]
      },
      {
        logo: '/ua/exclude.png',
        items: [{ role: 'exclude', label: 'Винятки IR', url: 'https://abie.app/exclude' }]
      },
      {
        logo: '/ua/imperson.jpeg',
        items: [{ role: 'imperson', label: 'Імперсоніфікація', url: 'https://abie.app/imperson/' }]
      },
      {
        logo: '/ua/sms.png',
        items: [{ role: 'sms', label: 'SMS Log', url: 'https://abie.app/sms' }]
      },
      {
        logo: '/ua/redline.jpeg',
        items: [{ role: 'gis', label: 'Red Line', url: 'https://redline.abie.app' }]
      },
      {
        title: 'Fleet UA',
        items: [
          { role: 'fleet-driver', label: 'Fleet Driver', url: 'https://abie.app/ft/driver' },
          { role: 'fleet-manager', label: 'Fleet Manager', url: 'https://abie.app/ft/manager' },
          { role: 'fleet-admin', label: 'Fleet Admin', url: 'https://fleet-admin.abie.app' }
        ]
      },
      {
        logo: '/ua/route.png',
        items: [{ role: 'route-manager', label: 'Route Manager', url: 'https://abie.app/route' }]
      },
      {
        logo: '/ua/contract.png',
        items: [{ role: 'contract', label: 'Pandora', url: 'https://abie.app/contract' }]
      },
      {
        logo: '/ua/kpi.png',
        items: [{ role: 'kpi', label: 'KPI', url: 'https://abie.app/kpi' }]
      },
      {
        logo: '/ua/apruv.png',
        items: [{ role: 'apruv', label: 'Погодження', url: 'https://abie.app/apruv' }]
      },
      {
        logo: '/ua/user.png',
        items: [{ role: 'user-admin', label: 'Користувачі', url: 'https://abie.app/user/' }]
      },
      {
        items: [{ role: 'inventario-mobile', label: 'Інвентаризація', url: 'https://abie.app/inventario/' }]
      },
      {
        title: 'Master-data',
        items: [{ role: 'master-data', label: 'Master-data', url: 'https://abie.app/master-data/' }]
      },
      {
        title: 'Notify',
        items: [{ role: 'notify', label: 'Notify', url: 'https://abie.app/notify' }]
      }
    ]

    break
  }
  case 'dev': {
    // DEV
    appList = [
      {
        logo: '/ua/caps.png',
        items: [
          { role: 'caps-user', label: 'СКіП', url: 'https://aiml.live/caps' },
          { role: 'caps-admin', label: 'СКіП Admin', url: 'https://aiml.live/partner-admin' },
          { role: 'partner-user', label: 'СКіП Partner', url: 'https://aiml.live/partner' }
        ]
      },
      {
        title: 'Catalina',
        items: [
          { role: 'catalina-user', label: 'Catalina', url: 'https://aiml.live/catalina' },
          { role: 'catalina-admin', label: 'Catalina Admin', url: 'https://aiml.live/catalina-admin' }
        ]
      },
      {
        logo: '/ua/atlas.png',
        items: [
          { role: 'atlas-user', label: 'Atlas PRO', url: 'https://aiml.live/atlas' },
          { role: 'atlas-admin', label: 'Atlas ADMIN', url: 'https://aiml.live/atlas-admin' }
        ]
      },
      {
        logo: '/ua/matrix.png',
        items: [
          { role: 'matrix-user', label: 'Matrix PRO', url: 'https://aiml.live/matrix' },
          { role: 'matrix-admin', label: 'Matrix PRO Admin', url: 'https://aiml.live/matrix-admin' }
        ]
      },
      {
        title: 'Обладнання',
        items: [{ role: 'equipment', label: 'Обладнання Admin', url: 'https://aiml.live/equipment/' }]
      },
      {
        title: 'Venom',
        items: [{ role: 'venom', label: 'Venom', url: 'https://venom.aiml.live' }]
      },
      {
        title: 'Анкети',
        items: [{ role: 'survey-admin', label: 'Анкети Admin', url: 'https://aiml.live/survey-admin' }]
      },
      {
        title: 'Контент',
        items: [{ role: 'content-admin', label: 'Контент Admin', url: 'https://aiml.live/content-admin' }]
      },
      {
        logo: '/ua/b2b.png',
        items: [
          // НЕ ЧІПАЄМО
          { role: 'b2b-admin', label: 'B2B Admin', url: 'https://admin-dev.vybeerai.com' }
        ]
      },
      {
        logo: '/ua/exclude.png',
        items: [{ role: 'exclude', label: 'Винятки IR', url: 'https://aiml.live/exclude' }]
      },
      {
        logo: '/ua/imperson.jpeg',
        items: [{ role: 'imperson', label: 'Імперсоніфікація', url: 'https://aiml.live/imperson/' }]
      },
      {
        logo: '/ua/sms.png',
        items: [{ role: 'sms', label: 'SMS Log', url: 'https://sms-ndev.web.app' }]
      },
      {
        title: 'TMAR',
        items: [{ role: 'tmar-user', label: 'TMAR', url: 'https://tmar.aiml.live' }]
      },
      {
        title: 'Fleet UA',
        items: [
          { role: 'fleet-driver', label: 'Fleet Driver', url: 'https://ft-driver-dev.web.app' },
          { role: 'fleet-manager', label: 'Fleet Manager', url: 'https://ft-manager-dev.web.app' },
          { role: 'fleet-admin', label: 'Fleet Admin', url: 'https://ft-admin-dev.web.app' }
        ]
      },
      {
        logo: '/ua/contract.png',
        items: [{ role: 'contract', label: 'Pandora', url: 'https://aiml.live/contract' }]
      },
      {
        logo: '/ua/kpi.png',
        items: [{ role: 'kpi', label: 'KPI', url: 'https://kpi.aiml.live' }]
      },
      {
        logo: '/ua/apruv.png',
        items: [{ role: 'apruv', label: 'Погодження', url: 'https://aiml.live/apruv' }]
      },
      {
        logo: '/ua/user.png',
        items: [{ role: 'user-admin', label: 'Користувачі', url: 'https://aiml.live/user/' }]
      },
      {
        items: [{ role: 'inventario-mobile', label: 'Інвентаризація', url: 'https://inventario.aiml.live/' }]
      },
      {
        title: 'Master-data',
        items: [{ role: 'master-data', label: 'Master-data', url: 'https://abie.app/master-data/' }]
      },
      {
        title: 'Notify',
        items: [{ role: 'notify', label: 'Notify', url: 'https://notify.abie.app/notify' }]
      }
    ]

    break
  }
}

/**
 * Завантажує профіль поточного користувача через URQL.
 * @returns {Promise<void>} повернене значення
 */
export const bootUser = async () => {
  consola.debug('Start User boot')

  const email = decodedUser?.['https://hasura.io/jwt/claims']?.['x-hasura-user-id']
  if (!email) return

  user.email = email
  user.avatar = gravatarUrl(email, { size: 160 })

  consola.debug('User boot before query')
  // Запрос на получение орг структуры пользователя
  const userResult = await graphqlClient
    .query(
      gql`
        query UserByPk($email: String!) {
          user_by_pk(email: $email) {
            role_auth0
            email_from
            name
          }
        }
      `,
      { email }
    )
    .toPromise()

  const data = userResult.data
  consola.debug('User boot after query')
  user.name = data?.user_by_pk?.name

  // разрешенные приложения пользователя
  const userApps = data?.user_by_pk?.role_auth0 || []
  const apps = []
  for (const app of appList) {
    const items = []
    for (const item of app.items) {
      if (userApps.includes(item.role)) {
        items.push(item)
      }
    }
    if (items.length) {
      apps.push({ ...app, items })
    }
  }
  user.apps = apps
  // console.log('apps', apps, data.user_by_pk?.role_auth0)

  consola.debug('End User boot', user)
}
